import type { TimeEvent } from "../../band-data/types";

const timeFormatter = new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
const dayFormatter = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" });

function isSameLocalDay(aMs: number, bMs: number): boolean {
    return new Date(aMs).toDateString() === new Date(bMs).toDateString();
}

/** Newer ICU puts a narrow no-break space before the period. */
function clock(ms: number): [time: string, period: string] {
    const [time = "", period = ""] = timeFormatter.format(ms).split(/\s/);
    return [time, period.toLowerCase()];
}

const withDay = (ms: number, text: string) => `${dayFormatter.format(ms)} ${text}`;

/** "6:00 – 9:00 am", "6:00 am – 2:00 pm", "Sep 19 10:05 pm – Sep 20 1:20 am"; "since 6:04 am" while running. */
export function formatSpan(event: TimeEvent, nowMs: number): string {
    const { startMs, endMs } = event;
    const [startTime, startPeriod] = clock(startMs);
    const startWithPeriod = `${startTime} ${startPeriod}`;

    if (endMs === null) {
        return `since ${isSameLocalDay(startMs, nowMs) ? startWithPeriod : withDay(startMs, startWithPeriod)}`;
    }

    const [endTime, endPeriod] = clock(endMs);
    const end = `${endTime} ${endPeriod}`;
    if (!isSameLocalDay(startMs, endMs)) return `${withDay(startMs, startWithPeriod)} – ${withDay(endMs, end)}`;

    const start = startPeriod === endPeriod ? startTime : startWithPeriod;
    return `${start} – ${end}`;
}
